import { Component, OnInit, TemplateRef, Input } from '@angular/core';

@Component({
    selector: 'shared-view-columns',
    templateUrl: './view-columns.shared.component.html',
    styleUrls: ['./view-columns.shared.component.scss']
})
export class ViewColumnsComponent implements OnInit {
    @Input() public verticalCenter: boolean = false;
    @Input() public verticalCenterLeft: boolean = false;
    @Input() public verticalCenterRight: boolean = false;
    @Input() public left: TemplateRef<any>;
    @Input() public right: TemplateRef<any>;
    constructor() { }

    ngOnInit(): void { }
}
